/*
 * Purpose: Administrator workspace — gated admin section with sub-routes
 * Last modified: 2026-06-28 | Agent
 * Completeness: 96
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminSubNav } from '@/components/admin/AdminSubNav';
import { AdminOverviewPanel } from '@/components/admin/AdminOverviewPanel';
import { SiteAnalyticsPanel } from '@/components/admin/SiteAnalyticsPanel';
import { AiAnalyticsPanel } from '@/components/admin/AiAnalyticsPanel';
import { WorkEngineerPanel } from '@/components/admin/WorkEngineerPanel';
import { APP_ROUTES } from '@/lib/appRoutes';

export default function AdminPage() {
  return (
    <div className="flex flex-col flex-1 min-h-0">
      <AdminSubNav />
      <Routes>
        <Route index element={<AdminOverviewPanel />} />
        <Route path="analytics" element={<SiteAnalyticsPanel />} />
        <Route path="ai-insights" element={<AiAnalyticsPanel />} />
        <Route path="engineer" element={<WorkEngineerPanel />} />
        <Route path="*" element={<Navigate to={APP_ROUTES.admin} replace />} />
      </Routes>
    </div>
  );
}
